import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SpreadPartial from '../spread-partial';

class Component extends BaseComponent {
    constructor(props) {
        super(props);


        this.state = {
            house: null,
            houses: props.positions.map(position => (position.title)),
        };
    }

    render({ type, positions }, { house, houses }) {
        return (
            <mandala-spread type={type} house={house}>
                {this.renderHouseSelector()}
                {this.renderImg()}
                <SpreadPartial
                    positions={positions.map((p, i) => ({ ...p, card_index: i }))}
                    houses={houses}
                />
            </mandala-spread>
        );
    }

    ordinal = (num) => {
        const j = num % 10;
        const k = num % 100;

        if (j == 1 && k != 11) {
            return num + 'st';
        }

        if (j == 2 && k != 12) {
            return num + 'nd';
        }

        if (j == 3 && k != 13) {
            return num + 'rd';
        }

        return num + 'th';
    };

    renderHouseSelector = () => {
        if (this.props.positions.length == 1) {
            return (
                <select onChange={this.changeHouse}>
                    <option disabled selected>Choose a House</option>
                    {this.state.houses.map((house, i) => (
                        <option value={house} selected={this.state.house == house}>
                            {`${this.ordinal(i + 1)} House - ${house}`}
                        </option>
                    ))}
                </select>
            );
        }

        return null;
    }

    changeHouse = (e) => {
        const house = e.target.value;

        this.setState({ house: house });
    }

    renderImg = () => {
        if (this.props.cards.length < this.props.positions.length) {
            let base_url = 'https://gfx.tarot.com/images/site/tarot/mandala-tarot-redux/';
            if (this.props.type) {
                base_url = `https://gfx.tarot.com/images/site/tarot/mandala-${this.props.type}-tarot-redux/`;
            }
            const image_filename = `${this.props.cards.length + 1}.svg`;

            return (
                <img src={base_url + image_filename} className='position-img' />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    positions: state.product && state.product.teeup && state.product.teeup.fields
        && state.product.teeup.fields[2] && state.product.teeup.fields[2].positions,
    cards: state['tarot-reading'] && state['tarot-reading'].cards,
});

export default connect(mapStateToProps)(Component);
